import React from 'react';
import { ContractsAnalysisState } from 'store/modules/contract_analysis/types';
import { ApplicationState } from 'store';
import { useSelector } from 'react-redux';
import Loader from 'components/atoms/loader';
import Pagination from 'components/atoms/pagination';
import ContractAnalysisItem from '../contract_analysis_Item';

interface ContractAnalysisListProps {
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

const ContractAnalysisList = ({ currentPage, setCurrentPage }: ContractAnalysisListProps) => {
  const { contract_analysis, request } = useSelector<ApplicationState, ContractsAnalysisState>(
    (state) => state.session.contract_analysis,
  );

  const paginate = (currentPage = 1) => {
    if (currentPage) {
      setCurrentPage(currentPage);
    }
  };

  return (
    <div className="px-3">
      <div className="card">
        <div className="card-header font-weight-bold">Contratos Conquistados</div>

        <div className="list-group list-group-flush">
          {request?.list_contract_analysis?.loading ? (
            <Loader />
          ) : contract_analysis?.total_entries === 0 ? (
            <div className="p-4 text-center text-muted">Não temos contratos analisados.</div>
          ) : (
            contract_analysis?.list_contract_analysis?.map((contract) => (
              <ContractAnalysisItem key={contract?.id} contract={contract} />
            ))
          )}
        </div>
        {contract_analysis?.total_entries > 7 && (
          <div className="row d-print-none m-0">
            <div className="col-md-12 px-4 my-3">
              <Pagination
                postsPerPage={7}
                totalPosts={contract_analysis?.total_entries}
                paginate={paginate}
                currentPage={currentPage}
                firstAndLastPage
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContractAnalysisList;
